import { __ } from "@wordpress/i18n";

export const suggestions = [
    {
        title: __("Professional Tone", "antimanual"),
        prompt: __(
            "Rewrite in a professional, engaging tone suitable for business audiences. Maintain a formal structure, fix grammatical errors, and ensure logical flow with clear headings. Keep the word count similar and enhance persuasiveness without adding unnecessary details.",
            "antimanual"
        ),
    },
    {
        title: __("Conversational and Engaging", "antimanual"),
        prompt: __(
            "Transform the content into a conversational style that feels like a friendly chat. Use simple language, contractions, and rhetorical questions to engage readers. Break up long paragraphs, add relatable examples, and maintain the original meaning while making it more approachable.",
            "antimanual"
        ),
    },
    {
        title: __("SEO Optimized", "antimanual"),
        prompt: __(
            "Rewrite to improve SEO by naturally incorporating relevant keywords (e.g., 'digital marketing strategies', 'content creation tips'). Ensure the content is keyword-rich but not stuffed, include long-tail phrases, and optimize for readability with short paragraphs and subheadings. Aim for a similar word count.",
            "antimanual"
        ),
    },
    {
        title: __("Simplify for Readability", "antimanual"),
        prompt: __(
            "Simplify complex sentences and jargon to improve readability. Use shorter words, active voice, and bullet points where appropriate. Break down ideas into digestible sections, maintain the core message, and ensure the content is accessible to a broader audience without losing depth.",
            "antimanual"
        ),
    },
    {
        title: __("Add Structure and Headings", "antimanual"),
        prompt: __(
            "Restructure the content with clear, descriptive headings and subheadings. Organize information logically, add introductory and concluding paragraphs if needed, and ensure smooth transitions between sections. Enhance clarity and scannability while preserving the original content's intent.",
            "antimanual"
        ),
    },
    {
        title: __("Make it Shorter and Concise", "antimanual"),
        prompt: __(
            "Condense the content by removing redundancies and unnecessary details. Focus on key points, use precise language, and maintain the essential information. Aim to reduce word count by 20-30% while keeping the message impactful and engaging.",
            "antimanual"
        ),
    },
    {
        title: __("Expand with More Details", "antimanual"),
        prompt: __(
            "Expand the content by adding relevant examples, explanations, and supporting details. Elaborate on key ideas without introducing new topics, use transitions for better flow, and increase word count by 20-30% to provide more value and depth.",
            "antimanual"
        ),
    },
    {
        title: __("Creative and Storytelling Style", "antimanual"),
        prompt: __(
            "Rewrite as a compelling story or narrative. Use vivid language, anecdotes, and emotional appeals to draw readers in. Maintain factual accuracy, structure it like a story with a beginning, middle, and end, and make it memorable while covering the original content.",
            "antimanual"
        ),
    },
    {
        title: __("Fix Grammar and Polish", "antimanual"),
        prompt: __(
            "Focus on correcting grammar, punctuation, and spelling errors. Improve sentence structure, eliminate passive voice where possible, and ensure consistent tense and style. Polish the language for professionalism without changing the meaning or adding new content.",
            "antimanual"
        ),
    },
    {
        title: __("Target Specific Audience", "antimanual"),
        prompt: __(
            "Adapt the content for a specific audience (e.g., beginners, experts, or industry professionals). Adjust vocabulary, examples, and depth accordingly. Use appropriate tone and references, and ensure the content resonates with the intended readers while staying true to the original.",
            "antimanual"
        ),
    },
];
